jQuery(document).ready(function($){
  $('.jump_to').click(function(){
    $('html, body').animate({
      scrollTop: $('#custom_collection_top').offset().top
    }, 800);
  });
  
  $('.custom_collection_item').click(function(){
    let target = $(this).data('id');
    $('html, body').animate({
      scrollTop: $('#' + target).offset().top
    }, 800);
  });

  $('.review_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 9000,
  })
});